export default __webpack_public_path__ + "static/media/0156.691ad499.jpg";